export function AuthLayout({ children }) {
  return children
}
